import { Promotion } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import { Skeleton } from "../ui/skeleton";
import Image from "next/image";
import { ClockIcon } from "@heroicons/react/24/solid";

type Props = {
  item: { promotions: Promotion[], isHome?: boolean };
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const PromotionCard = ({ item }: Props ) => {
  const promotion = item.promotions[0];
  const formattedDate = formatDate(promotion.endDate);
  const isHome = item.isHome ?? false;
  
  const promotionUrl = promotion.link
    ? promotion.link
    : ROUTES.promotions.details(promotion.slug);

  return (
    <Link
      href={promotionUrl}
      target={promotion.isBlank === "1" ? "_blank" : "_self"}
      rel="noopener noreferrer"
      className={`relative border border-gray02 flex flex-col bg-white group hover:border-yellow02 h-full gap-4  ${promotion.tag ?? ''}`}
    >
      <div className="w-full overflow-hidden p-2 pb-0">
        <div className="aspect-[1000/470] relative">
          <Image
            fill
            className="object-cover rounded-md ![will-change:auto]"
            src={promotion.fullMedia}
            alt={promotion.title}
            quality={100}
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          />
        </div>
      </div>

      <div className=" px-4 flex flex-col flex-1">
        <div className="flex-1 text-dark02">
          <h3
            className={`text-base font-bold overflow-hidden text-ellipsis uppercase line-clamp-1 min-h-[23px]`}
          >
            {promotion.title}
          </h3>

          {promotion.hideDate === 2 && (
            <p className=" uppercase">VIG / {formattedDate}</p>
          )}
        </div>
      </div>

      <div className={`w-full bg-gray01 py-2 px-4 group-hover:bg-yellow02 flex  ${promotion.countdown_text ? 'justify-between' : 'justify-end'}`}>
        {promotion.countdown_text && (
          <div className={`text-left text-red-700 w-full sm:w-9/12 md:w-3/4 flex items-center gap-1 tablet-only:text-xs ${isHome ? 'desktop-narrow:text-xs' : ''}`}>
            <ClockIcon className="h-5 w-5" /> {promotion.countdown_text}
          </div>
        )}
        <div className={`text-right text-dark02 font-semibold w-full sm:w-3/12 md:w-1/4 flex items-center justify-end tablet-only:text-xs ${isHome ? 'desktop-narrow:text-xs' : ''}`}>
          VER MÁS
        </div>
      </div>
    </Link>
  );
};

export default PromotionCard;


export function PromotionCardSkeleton() {
  return (
    <div className="relative border border-gray02 flex flex-col bg-white h-full gap-4">
      <div className="w-full overflow-hidden p-2 pb-0">
        <div className="aspect-[100/47] relative">
          <Skeleton className="absolute inset-0" />
        </div>
      </div>

      <div className="px-4 flex flex-col flex-1">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>
      </div>

      <div className="w-full">
        <Skeleton className="h-[40px] rounded-none" />
      </div>
    </div>
  );
}
